/**
 * Scroll to a shared item on arrival.
 *
 * Visitors redirected from a shareable post land with a `share` query param
 * (`shareable-{post}-{layout}`) matching the component's element ID. The URL
 * also carries a matching hash, but some platforms strip fragments when a
 * link is shared, so the param is the reliable signal.
 */
function scrollToSharedItem() {
	const params = new URLSearchParams(window.location.search);
	const target = String(params.get('share') || '').trim();
	if (!target) return;

	const element = document.getElementById(target);
	if (!element) return;

	// When the hash survived the redirect, jump.js already scrolls to it.
	if (window.location.hash.substring(1) === target) return;

	window.setTimeout(() => {
		element.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}, 250);
}

window.addEventListener('load', scrollToSharedItem);
